import { Entity } from "@backstage/catalog-model";

export const useEntityRef = ({ entity }: { entity: Entity }) => {
  if (
    !entity ||
    !entity.metadata ||
    !entity.metadata.namespace ||
    !entity.kind
  ) {
    return entity.metadata.name;
  }

  const namespace = entity.metadata.namespace.toLowerCase();
  const kind = entity.kind.toLowerCase();
  const name = entity.metadata.name;

  return `${kind}:${namespace}/${name}`;
};
